import { useState, useEffect } from 'react';
import formatDeviceData, { getAllCategoriesKey } from './utils/formatDeviceData';
import getSubCategoryOptions from './utils/getSubCategoryOptions';
var useFilterDevices = function (deviceType, devices, categories, setDevices, defaultFilter, defaultSubFilter, lang) {
    var _a = useState([]), filteredDevicesByCategory = _a[0], setFilteredDevicesByCategory = _a[1];
    var _b = useState(''), activeCategoryFilter = _b[0], setActiveCategoryFilter = _b[1];
    var _c = useState(''), activeSubCategoryFilter = _c[0], setActiveSubCategoryFilter = _c[1];
    var _d = useState([]), subCategoryOptions = _d[0], setSubCategoryOptions = _d[1];
    // First value of the main category
    var categoryAll = getAllCategoriesKey(deviceType);
    // First value of the subcategory
    var subcategoryAll = lang === 'en' ? 'All' : 'Tout';
    // Filter the devices by subcategory based on previous category filters and maintain any promotional blocks or devices with no subcategory.
    var filterBySubCategory = function (subCategory, items, optionsToFilterBy) {
        if (optionsToFilterBy === void 0) { optionsToFilterBy = []; }
        var validSubCategory = subcategoryAll.toLowerCase();
        var options = subCategoryOptions;
        if (optionsToFilterBy.length > 0) {
            options = optionsToFilterBy;
        }
        if (options.find(function (option) { return option.value === subCategory.toLowerCase(); })) {
            validSubCategory = subCategory.toLowerCase();
        }
        var filteredBySubCategory = items.filter(function (device) {
            var _a, _b, _c;
            return validSubCategory === subcategoryAll.toLowerCase()
                ? ((_a = device === null || device === void 0 ? void 0 : device.brand) === null || _a === void 0 ? void 0 : _a.name) || !((_b = device === null || device === void 0 ? void 0 : device.brand) === null || _b === void 0 ? void 0 : _b.name)
                : !(device === null || device === void 0 ? void 0 : device.brand) || // eslint-disable-line @typescript-eslint/prefer-optional-chain
                    !((_c = device === null || device === void 0 ? void 0 : device.brand) === null || _c === void 0 ? void 0 : _c.name) ||
                    device.brand.name.toLowerCase() === validSubCategory;
        });
        setDevices(filteredBySubCategory);
        setActiveSubCategoryFilter(validSubCategory);
    };
    // Filter the devices by category, set the appropriate subcategory filters and active filter.
    var filterByCategory = function (category) {
        var _a;
        var machineNameCategories = formatDeviceData(deviceType, devices).machineNameCategories;
        var validCategory = categoryAll;
        if (machineNameCategories.includes(category.toLowerCase())) {
            validCategory = category.toLowerCase();
        }
        var filteredByCategory = devices.filter(function (device) {
            var _a, _b, _c;
            if (((_a = device === null || device === void 0 ? void 0 : device.categories) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                return true;
            }
            var lowerCaseCategories = (_c = (_b = device === null || device === void 0 ? void 0 : device.categories) === null || _b === void 0 ? void 0 : _b.map(function (deviceCategory) { return deviceCategory.toLowerCase(); })) !== null && _c !== void 0 ? _c : [];
            return lowerCaseCategories.includes(validCategory);
        });
        // Get the subcategory options associated with the filtered results.
        var options = (_a = getSubCategoryOptions(filteredByCategory, subcategoryAll)) !== null && _a !== void 0 ? _a : [];
        setSubCategoryOptions(options);
        setActiveCategoryFilter(validCategory);
        // Maintain the devices filtered by category for filtering by subcategory.
        setFilteredDevicesByCategory(filteredByCategory);
        // On first render we will not yet have an active sub category filter and if we have a default sub filter we need to have the filteredByCategory devices filtered by sub category as well.
        if (!activeSubCategoryFilter && defaultSubFilter) {
            filterBySubCategory(defaultSubFilter, filteredByCategory, options);
        }
        // If a previous selected subcategory exists in the selected category then filter by subcategory as well.
        else if (activeSubCategoryFilter &&
            options.find(function (option) { return option.value === activeSubCategoryFilter.toLowerCase(); })) {
            filterBySubCategory(activeSubCategoryFilter, filteredByCategory, options);
        }
        else {
            // Otherwise set the subcategory to 'All' and show the devices filtered by category and save the values in local storage.
            if (activeSubCategoryFilter &&
                !options.find(function (option) { return option.value === activeSubCategoryFilter.toLowerCase(); })) {
                setActiveSubCategoryFilter(subcategoryAll);
            }
            setDevices(filteredByCategory);
        }
    };
    // Filter the devices by category when select option (mobile) or button is clicked.
    var filterDevicesByCategory = function (e) {
        if (e === void 0) { e = ''; }
        // If the event target has options then the select component is being used so target the value instead of the id.
        filterByCategory(e);
    };
    // Filter the devices by subCategory when select option is clicked.
    var filterDevicesBySubCategory = function (e) {
        filterBySubCategory(e, filteredDevicesByCategory);
    };
    useEffect(function () {
        filterByCategory(defaultFilter !== null && defaultFilter !== void 0 ? defaultFilter : categories[0]);
    }, [defaultFilter, defaultSubFilter]);
    return {
        activeCategoryFilter: activeCategoryFilter,
        activeSubCategoryFilter: activeSubCategoryFilter,
        subCategoryOptions: subCategoryOptions,
        filterDevicesByCategory: filterDevicesByCategory,
        filterDevicesBySubCategory: filterDevicesBySubCategory
    };
};
export default useFilterDevices;
